import { gameConstants } from '../constants';

const initialState = {
    loading: false,
    games: [],
    error: null,
    creatingGame: false,
    createError: null,
    updatingGame: false,
    updateError: null,
};

const gameReducer = (state = initialState, action) => {
    switch (action.type) {
        case gameConstants.FETCH_GAME_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case gameConstants.FETCH_GAME_SUCCESS:
            return {
                ...state,
                loading: false,
                games: action.games,
                error: null
            };
        case gameConstants.FETCH_GAME_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case gameConstants.CREATE_GAME_REQUEST:
            return {
                ...state,
                creatingGame: true,
                createError: null,
            };
        case gameConstants.CREATE_GAME_SUCCESS:
            return {
                ...state,
                creatingGame: false,
                games: action.games,
            };
        case gameConstants.CREATE_GAME_FAILURE:
            return {
                ...state,
                creatingGame: false,
                createError: action.payload,
            };
        case gameConstants.UPDATE_GAME_REQUEST:
            return {
                ...state,
                updatingGame: true,
                updateError: null,
            };
        case gameConstants.UPDATE_GAME_SUCCESS:
            return {
                ...state,
                updatingGame: false,
                games: action.games
            };
        case gameConstants.UPDATE_GAME_FAILURE:
            return {
                ...state,
                updatingGame: false,
                updateError: action.payload,
            };
        case gameConstants.UPDATE_SEQUENCE_REQUEST:
            return {
                ...state,
                updatingGame: true,
                updateError: null,
            };
        case gameConstants.UPDATE_SEQUENCE_SUCCESS:
            return {
                ...state,
                updatingGame: false,
                games: action.games
            };
        case gameConstants.UPDATE_SEQUENCE_FAILURE:
            return {
                ...state,
                updatingGame: false,
                updateError: action.payload,
            };
        default:
            return state;
    }
};

export default gameReducer;
